//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams, toCopy} from '@/utils/util.js'
import homeTip from '@/components/homeTip'
import bottom from '@/assets/img/bottom.png'
import {Dialog, Toast} from 'vant';

export default {
  name: "qualityAudit",
  components: {
    homeTip
  },
  data() {
    return {
      show:false,
      bottom,
      checkAll: false,
      isSend: false,
      loading: false,
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      createMessage:{stockInSn:'',redoneOrderSn:'',returnOrderSn:'',qualityOrderSn:'',sendOrderSn:''},
      dialogFormVisible: false,
      isAllQualityStr: '否',
      isFullQualityStr: '全部全检',
      isStockInStr: '是',
      isRedoneStr: '否',
      redoneTypeStr: '',
      toCopy,
      reasonShow: false,
      columns: [{text: '是', value: 1}, {text: '否', value: 0}],
      columns1: [{text: '全部全检', value: 1}, {text: '部分全检', value: 0}],
      columns2: [{text: '现场返工', value: 1}, {text: '退回返工', value: 2}],
      popReason: '',
      list: [],
      reasonList: [
      ],
      auditForm: {
        isAllQuality: 0,
        isFullQuality: 1,
        isStockIn: 1,
        isRedone: 0,
        redoneType: null,
      },
      basicForm: {
        spuCode: '',
        isAllQuality: 0,
        isFullQuality: 1,
        isStockIn: 1,
        isRedone: 0,
        redoneType: null,
        purchaseRemark: '',
        qualityOrderSn: '',
        sendOrderSn: '',
        purchaseOrderSn: '',
        supplierName: '',
        channelStr: '',
        qualityOrderTypeName: '',
        qualityOrderDetailList: [],
        qualityOrderResultDetailList: [],
        isStockIn: '',
        confirmFileStr: '',
        confirmFile: '',
        remark: '',
        qualityResult: '',
        qualityOrderStatusName: '',
        billDate: '',
        attachedFile: [],
        spotCheckTotalNum: '',
        goodTotalNum: '',
        normalTotalNum: '',
        badTotalNum: '',
        sendTotalGoodsNum: 0,
        rejectNum: '',
        colorList: [],
        colorResultList: [],
        deliveryName: '',
        realitySupplierName: '',
        qualityType: '',
      },
      dataList: {},
      aduitParams: {},
      qualityOrderId: '',
      qualityResultId: '',
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.qualityOrderId) {
      this.qualityOrderId = this.$route.query.qualityOrderId
    }
    this.getSpecList()
  },
  methods: {
    getSpecList() {
      var queryParams = {
        qualityOrderId: this.qualityOrderId
      };
      axiosApi.queryQualityOrderResult(queryParams).then(response => {
        var data = response.content;
        // if (data.qualityOrderDetailList) {
        //   data.qualityOrderDetailList.forEach((item) => {
        //     item.isEdit = true
        //   })
        // }
        for (var ind in data) {
          var val = data[ind] != null ? data[ind] : ""
          this.$set(this.basicForm, ind, val)
        }
        var channelStr = '';
        if (this.basicForm.firstDeptName) {
          channelStr += this.basicForm.firstDeptName
        }
        if (this.basicForm.secondDeptName) {
          channelStr += '/' + this.basicForm.secondDeptName
        }
        this.$set(this.basicForm, 'channelStr', channelStr)
        if (data.colorResultList && data.colorResultList.length > 0) {
          for (let i in data.colorResultList) {
            if (data.colorResultList[i].detailList) {
              data.colorResultList[i].detailList.forEach((item) => {
                item.isEdit = true
              })
            }
            data.colorResultList[i].percent = 0
            if (data.colorResultList[i].spotCheckTotalNum && data.colorResultList[i].goodTotalNum) {
              data.colorResultList[i].percent = ((data.colorResultList[i].goodTotalNum / data.colorResultList[i].spotCheckTotalNum) * 100).toFixed(2)
            }
            // console.log(this.$refs)
          }
        }

        console.log('11')
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    showDetail(remark) {
      this.popReason = remark
      this.reasonShow = true
    },
    getColor(list) {
      return (list.map((item) => {
        return item.name
      }).join(' '))
    },
    toMore() {
      this.$router.push({name: 'qualityOrderDetailMore'})
    },
    toBase() {
      this.$router.push({name: 'qualityOrderDetailBase'})
    },
    toAddReason() {
      this.$router.push({name: 'addReason', type: 2})
    },
    open() {
      this.showPicker = true
    },
    onConfirm(value) {
      this.isAllQualityStr = value.text;
      this.auditForm.isAllQuality = value.value;
      this.showPicker = false;
    },
    open1() {
      this.showPicker1 = true
    },
    onConfirm1(value) {
      this.isFullQualityStr = value.text;
      this.auditForm.isFullQuality = value.value;
      this.showPicker1 = false;
    },
    open2() {
      this.showPicker2 = true
    },
    onConfirm2(value) {
      this.isStockInStr = value.text;
      this.auditForm.isStockIn = value.value;
      if(this.auditForm.isStockIn = 1){
        this.auditForm.isRedone = 0;
        this.isRedoneStr = "否";
      }
      this.showPicker2 = false;
    },
    open3() {
      this.showPicker3 = true
    },
    onConfirm3(value) {
      this.isRedoneStr = value.text;
      this.auditForm.isRedone = value.value;
      this.showPicker3 = false;
    },
    open4() {
      this.showPicker4 = true
    },
    onConfirm4(value) {
      this.redoneTypeStr = value.text;
      this.auditForm.redoneType = value.value;
      this.showPicker4 = false;
    },
    channelSubmit() {
      if (this.isSend) return
      this.isSend = true
      if (this.auditForm.isFullQuality == 1) {
        var queryParams1 = {
          ...this.auditForm,
          qualityOrderId: this.qualityOrderId,
        }
        axiosApi.aduitQualityOrder(queryParams1).then(response => {
          this.isSend = false
          Toast.success('操作成功');
          this.createMessage.stockInSn = response.content.stockInSn||'';
          this.createMessage.redoneOrderSn = response.content.redoneOrderSn||'';
          this.createMessage.returnOrderSn = response.content.returnOrderSn||'';
          this.createMessage.qualityOrderSn = response.content.qualityOrderSn||'';
          this.createMessage.sendOrderSn = response.content.sendOrderSn||'';
          this.show = true;
        }).catch(error => {
          this.isSend = false
        })
      } else {
        this.isSend = false
        this.queryDetail()
      }
    },
    queryDetail() {
      var queryParams = {
        rejectFlag: 1,
        qualityOrderId: this.qualityOrderId
      };
      axiosApi.queryQualityOrderDetail(queryParams).then(response => {
        if (response.content && response.content.length > 0) {
          response.content.forEach((item) => {
            item.choose = false
          })
          this.list = response.content
        } else {
          this.list = []
        }
        this.dialogFormVisible = true
      }).catch(error => {
      })
    },
    onSubmit1() {
      if (this.isSend) return
      this.isSend = true
      var list = this.list.filter((item) => {
        return item.choose == true
      })
      if (list.length == 0) {
        Toast.fail('请选择');
        this.isSend = false
        return
      }
      var queryParams1 = {
        ...this.auditForm,
        qualityOrderId: this.qualityOrderId,
        qualityOrderDetailList: list
      }
      axiosApi.aduitQualityOrder(queryParams1).then(response => {
        this.dialogFormVisible = false
        this.isSend = false
        Toast.success('操作成功');
        this.createMessage.stockInSn = response.content.stockInSn||'';
        this.createMessage.redoneOrderSn = response.content.redoneOrderSn||'';
        this.createMessage.returnOrderSn = response.content.returnOrderSn||'';
        this.createMessage.qualityOrderSn = response.content.qualityOrderSn||'';
        this.createMessage.sendOrderSn = response.content.sendOrderSn||'';
        this.show = true;
      }).catch(error => {
        this.isSend = false
      })
    },
    dialogClose(){
      this.$router.back(-1)
    },
    chooseConfirm() {
      var list = this.list.filter((item) => {
        return item.choose == true
      })
      if (list.length == 0) {
        Toast.fail('请选择');
        return
      } else {
        this.$router.push({name: 'qualityWrite', query: {data: JSON.stringify(list)}})
      }
    },
    chooseAll() {
      let a = this.checkAll;
      this.list = this.list.map(e => {
        e.choose = a;
        return e;
      });
    },
    choose() {
      let a = true;
      this.list.forEach(e => {
        if (e.choose === false) {
          a = false;
        }
      });
      console.log(a)
      this.checkAll = a;
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/qualityAudit.vue